import { Unstable_Grid2 as Grid } from '@mui/material';
import { ComponentType, PropsWithChildren, ReactElement, ReactNode } from 'react';
import FormSectionTitle from './FormSectionTitle';

const render = (el: ReactNode) => {
    if (!el) {
        return null;
    }

    if ((el as any).type === Grid) {
        return el;
    }

    return (
        <Grid xs={12} md={6}>
            {el}
        </Grid>
    );
};

const FormSection: ComponentType<PropsWithChildren<{ label?: string, rowSpacing?: number }>> = ({
                                                                                                    label,
                                                                                                    children,
                                                                                                    rowSpacing = 0
                                                                                                }) => {
    return (
        <Grid container spacing={2} sx={{ mb: 2 }}>
            {label && (
                <Grid xs={12}>
                    <FormSectionTitle>{label}</FormSectionTitle>
                </Grid>
            )}

            <Grid xs={12} container rowSpacing={rowSpacing} columnSpacing={2}>
                {Array.isArray(children)
                    ? children.map((el) => render(el))
                    : render(children)}
            </Grid>
        </Grid>
    );
};

export default FormSection;
